import { z } from 'zod';
import { idSchema } from './common';

export const allowedNetworkSchema = z.object({
  id: idSchema,
  cidr: z.string().describe('A range in CIDR notation, normalised; one address is a /32 (IPv4) or /128 (IPv6)'),
  label: z.string().nullable(),
  createdByName: z.string().nullable(),
  createdAt: z.string(),
});
export type AllowedNetworkDto = z.infer<typeof allowedNetworkSchema>;

export const allowedNetworksSchema = z.object({
  networks: z.array(allowedNetworkSchema).describe('Empty: staff are not limited by address'),
  yourAddress: z.string().describe('The address this request came from, as the API sees it'),
  yourAddressListed: z.boolean().describe('Whether one of the networks includes yourAddress'),
});
export type AllowedNetworksDto = z.infer<typeof allowedNetworksSchema>;

export const createAllowedNetworkSchema = z.object({
  cidr: z.string().trim().min(1).max(64).describe('An IPv4 or IPv6 address, or a range such as 203.0.113.0/24; 422 INVALID_NETWORK otherwise'),
  label: z.string().trim().max(80).nullable().optional(),
  confirmOutside: z.boolean().default(false).describe('Save even though the list would not include your own address; 409 ADDRESS_OUTSIDE_NETWORKS otherwise'),
});
export type CreateAllowedNetworkInput = z.infer<typeof createAllowedNetworkSchema>;

export const removeAllowedNetworkQuerySchema = z.object({
  confirmOutside: z.stringbool().default(false).describe('Remove it even though the rest of the list would not include your own address'),
});
